<template>
  <div class="compressed-content">
    <h3 class="page-question">Which range best describes your highest LDL cholesterol?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.highestCholesterolRange">
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.highestCholesterolRange" name="cholesterol"
                    :value=cholesterolRange.Unknown>
        Don’t know
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.highestCholesterolRange" name="cholesterol"
                    :value=cholesterolRange.VeryHigh>
        310 mg/dL or less
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.highestCholesterolRange" name="cholesterol"
                    :value=cholesterolRange.Between>
        Between 311-400 mg/dL
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.highestCholesterolRange" name="cholesterol"
                    :value=cholesterolRange.Higher>
        400 mg/dL or higher
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import cholesterolRange from "enums/cholesterol-range";
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    data() {
      return {
        cholesterolRange: cholesterolRange,
      };
    },

    validations: {
      highestCholesterolRange: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      highestCholesterolRange() { return this.survey.bloodBiochemistry.cholesterol.highestCholesterolRange; }
    }
  };
</script>